import { db } from './database';
import { AppSettings } from '../types';

export const DEFAULT_SETTINGS: AppSettings = {
  id: 'global_settings',
  soundEnabled: true,
  masterVolume: 0.75,
  defaultSpinDuration: 5,
  removeWinnerAfterSpin: false,
  confettiEnabled: true,
  reduceMotion: false,
  theme: 'dark',
  colorPalette: 'vibrant',
  autoOpenWinnerModal: true,
  wheelNameFontSize: 24,
};

export async function getSettings(): Promise<AppSettings> {
  const settings = await db.settings.get('global_settings');
  if (!settings) {
    await db.settings.put(DEFAULT_SETTINGS);
    return DEFAULT_SETTINGS;
  }
  return settings;
}

export async function updateSettings(updates: Partial<AppSettings>): Promise<AppSettings> {
  const current = await getSettings();
  const updated: AppSettings = {
    ...current,
    ...updates,
  };
  await db.settings.put(updated);
  return updated;
}
